export default __webpack_public_path__ + "static/media/group_5171.897ea25d.png";